import * as actions from "./actionsTypes";

const initialState = {
  requests: [],
  loading: false,
  saving: false,
  error: null,
};

export default function vacationRequestsReducer(state = initialState, action) {
  switch (action.type) {
    case actions.IS_LOADING_VACATION_REQUESTS:
      return { ...state, loading: action.payload, error: null };

    case actions.GET_VACATION_REQUESTS:
      return { ...state, requests: action.payload, error: null };

    case actions.FAIL_VACATION_REQUESTS:
      return { ...state, error: action.payload };

    case actions.IS_SAVE_VACATION_REQUEST:
      return { ...state, saving: action.payload };

    case actions.FAIL_SAVE_VACATION_REQUEST:
      return { ...state, error: action.payload };

    case actions.CLEAR_ERROR:
      return { ...state, error: null };

    case actions.UPDATE_VACATION_REQUEST_SUCCESS:
      return {
        ...state,
        requests: state.requests.map(r =>
          r.id === action.payload.id ? action.payload : r
        ),
        error: null
      };


    default:
      return state;
  }
}